import { DARK_MODE } from "./dark-mode";

export const Github = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>{DARK_MODE}</style>
    <g clipPath="url(#clip0_505_1582)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.97616 0.163269C3.56555 0.163269 0 3.75511 0 8.1987C0 11.7507 2.28457 14.7574 5.45388 15.8216C5.85012 15.9016 5.99527 15.6487 5.99527 15.4359C5.99527 15.2496 5.9822 14.6111 5.9822 13.9458C3.76343 14.4248 3.30139 12.9879 3.30139 12.9879C2.94482 12.0567 2.41649 11.8173 2.41649 11.8173C1.69029 11.3251 2.46939 11.3251 2.46939 11.3251C3.27494 11.3783 3.69763 12.1499 3.69763 12.1499C4.41061 13.3737 5.55951 13.0279 6.02171 12.815C6.08767 12.2962 6.2991 11.937 6.52359 11.7375C4.75396 11.5512 2.89208 10.8594 2.89208 7.7729C2.89208 6.89486 3.20882 6.17649 3.71069 5.6178C3.63151 5.41829 3.35412 4.59331 3.79004 3.48915C3.79004 3.48915 4.46351 3.27625 5.98204 4.31396C6.63218 4.13807 7.30265 4.04859 7.97616 4.04784C8.64963 4.04784 9.33616 4.14106 9.97012 4.31396C11.4888 3.27625 12.1623 3.48915 12.1623 3.48915C12.5982 4.59331 12.3207 5.41829 12.2415 5.6178C12.7566 6.17649 13.0602 6.89486 13.0602 7.7729C13.0602 10.8594 11.1984 11.5378 9.41551 11.7375C9.70612 11.9902 9.9569 12.4691 9.9569 13.2274C9.9569 14.305 9.94384 15.1698 9.94384 15.4358C9.94384 15.6487 10.0891 15.9016 10.4852 15.8217C13.6545 14.7572 15.9391 11.7507 15.9391 8.1987C15.9522 3.75511 12.3736 0.163269 7.97616 0.163269Z"
        fill="#24292F"
      />
    </g>
    <defs>
      <clipPath id="clip0_505_1582">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
